import { AEMErrorMessage } from '../../../models';

export const UpgradesErrorMessage: AEMErrorMessage = {
  action: {
    label: 'View All Vouchers and Credits',
    url: '/myprofile/certificates',
    id: 'viewVoucherseCredits'
  },
  component: 'upgrades',
  errorId: [
    {
      errorCode: 'CRD_5002'
    },
    {
      errorCode: 'CRD_2000'
    },
    {
      errorCode: 'CRD_5000'
    },
    {
      errorCode: 'CRD_2006'
    },
    {
      errorCode: 'CRD_1000'
    },
    {
      errorCode: 'CRD_5001'
    },
    {
      errorCode: 'CRD_4000'
    },
    {
      errorCode: '702'
    }
  ],
  featureTitle: 'Elevate Your Next Flight',
  errorMessageDescription:
    'Sorry, we’re currently unable to display your Vouchers and Credits. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
